import { NOT_FOUND } from '@mm/constants/status-codes';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import commonHandler, { ResponseOrError } from './common-handler';

export const planInfoHandler =
  (dispatch: Dispatch<StoreState>) => async (error: ResponseOrError) => {
    if (error instanceof Response && error.status === NOT_FOUND) {
      throw error;
    }
    commonHandler(dispatch)(error);
  };
